import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrl, baseUrl } from "../../../utils/apis";
import { FaqItem, FaqPayload, FaqResponse } from "./types";



export const faqApiFetching = createApi({
    reducerPath: "faqApi",
    baseQuery: fetchBaseQuery({
        baseUrl,

        prepareHeaders: (headers) => {
            const token = sessionStorage.getItem("token");

            headers.set("Content-Type", "application/json");

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;

        },
    }),
    tagTypes: ["Faq"],

    endpoints: (builder) => ({
        getFaqList: builder.query<FaqResponse, void>({
            query: () => ({
                url: apiUrl.faqUrl,
                method: "GET",
                providesTags: ["Faq"],

            }),

        }),

        postFaq: builder.mutation({
            query: (bodyData: FaqPayload) => ({
                url: apiUrl.faqUrl,
                method: "POST",
                body: bodyData,
            }),
            invalidatesTags: ["Faq"],
        }),
        updateFaq: builder.mutation<FaqItem, { id: number | string; data: Partial<FaqItem>, }>({
            query: ({ id, data }) => ({
                url: `${apiUrl.faqUrl}${id}/`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Faq"],
        }),
        deleteFaq: builder.mutation<{ success: boolean; message: string }, number>({
            query: (id) => ({
                url: `${apiUrl.faqUrl}${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["Faq"], 
        }),
    }),
});

export const { useGetFaqListQuery, usePostFaqMutation, useUpdateFaqMutation,useDeleteFaqMutation } = faqApiFetching;






